import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './usuarioImobiliariaForm';

import { setModoTela, initForm, salvar, alterarSenha, excluir, getLista, salvarPermissao, getListaImobiliaria } from './usuarioActions';

class UsuarioImobiliaria extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
        this.props.getListaImobiliaria();
    }

    render() {
        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'cadastroSenha' ? (
						<Form cadastroSenha onSubmit={this.props.alterarSenha} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					{this.props.usuarioCarregado &&
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Adm'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  id_imobiliaria: this.props.usuarioCarregado.id_imobiliaria, administrador: false, imobiliaria: true, corretor: false });
								}} />
						</Grid>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Corretor'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({  id_imobiliaria: this.props.usuarioCarregado.id_imobiliaria, administrador: false, imobiliaria: false, corretor: true });
								}} />
						</Grid>
					</Row>}
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th alignCenter colspan={1}>Nome</Th>
								<Th alignCenter colspan={1}>Login</Th>
								<Th alignCenter colspan={1}>Imobiliária</Th>
								<Th alignCenter>Acesso</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{(this.props.lista).filter(item => {
								if (this.state.pesquisar
									&& !(`${item.nome} ${item.login} ${item.nome_imobiliaria}`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}
								return true;
							}).map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td alignCenter>{item.nome}</Td>
									<Td alignCenter>{item.login}</Td>
									<Td alignCenter>{item.nome_imobiliaria}</Td>
									<Td alignCenter>{item.administrador ? 'Administrador' : (item.imobiliaria ? 'Imobiliária' : 'Corretor')}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item,
													imobiliarias: (item.imobiliarias || []).map(item => item.id)
												});
												this.props.initForm({
													...item,
													imobiliarias: (item.imobiliarias || []).map(item => item.id)
												});
											}} />

										<ButtonTable
											type={'warning'}
											icon={'fas fa-lock'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastroSenha', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item,
													senha: null
												});
												this.props.initForm({
													...item,
													senha: null
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.usuario.modoTela,
	lista: state.usuario.lista.filter(item => {
		if (!state.auth.usuarioCarregado || item.id_imobiliaria != state.auth.usuarioCarregado.id_imobiliaria) {
			return false;
		}

		return true;
	})
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, alterarSenha, excluir, getLista, salvarPermissao, getListaImobiliaria }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioImobiliaria);
